import { BaseDto } from "./base.dto"

export class HeaderPromotionDto extends BaseDto {
  text: string
  textKh: string
  enabled: boolean
  timerSec: number

  static create() {
    return new HeaderPromotionDto()
  }
}

export class UpdateHeaderPromotionDto {
  text?: string
  textKh?: string
  enabled?: boolean
  timerSec?: number
}

export class CreateHeaderPromotionDto {
  text: string
  textKh: string
  timerSec: number
}